/*
 * SUM-RETENTION-AMOUNT.JS - Retention Amount Calculation Utility for Progress Claims
 * 
 * SUMMARY:
 * A utility function that calculates the total retention amounts and claim amounts
 * for a specific project, excluding the current progress claim being processed.
 * Used in preview-budget functionality to determine retention calculations.
 */

const { getAllProgressClaimList } = require("../../../../../../actions/project-management.action");

export const sumRetentionAmount = async ({ projectId, progressClaimId, dispatch }) => {
    let claimsRetainedTotal = 0; // total retained to date (sum of retentions withheld)
    let claimsRetentionClaimTotal = 0; // total of all previous claims (sum of claim amounts)
    if (projectId) {
        const progressClaims = await dispatch(getAllProgressClaimList(projectId)).catch(e => console.log(e));
        if (Array.isArray(progressClaims)) {
            progressClaims.forEach((claim) => {
                if (claim.id !== progressClaimId) {
                    claimsRetainedTotal += parseFloat(claim.retentionAmount || 0);
                    // Claimed Amount should be total of all previous claims
                    claimsRetentionClaimTotal += parseFloat(claim.claimAmount || 0);
                }
            });
        }
    }
    return { claimsRetainedTotal, claimsRetentionClaimTotal };
};